$('#option_sector').on('change', function (e) {
    let val = $(this).find('option:selected').val();
    let el1 = $('#div_sector_other');
    let el2 = $('#option_sector_other');

    if (val == 'WIS_ABAS_YTERGDL') {
        $(el1).removeClass('d-none').show();
        $(el2).prop('required', true);
    } else {
        $(el1).addClass('d-none').hide();
        $(el2).prop('required', false);
    }
    $('#fpartner').validator('update');
});

$(".custom-file-input").on('change', function (e) {
    var obj = $(e.currentTarget).attr('id');
    var objno = obj.substring(obj.length - 2);
    //console.log(obj);

    var filename = e.target.files[0].name;
    $("label[for='" + obj + "']").empty().html(filename);
});

$('#c_country').on('change', function (e) {
    let countrycode = JSON.parse(Base64.decode($('meta[name="forms.countrycode"]').attr('content')));
    let val = $(this).find('option:selected').val();
    console.log(countrycode[val]);
    $('#countrycode').val(countrycode[val]);
    $("span[id$='-addon']").text(countrycode[val]);
});

let form = $('#fpartner');
/*
$(form).on('invalid.bs.validator', function(e) {
    console.log(e);
})
*/

$(form).validator().on('submit', function (e) {
    if (e.isDefaultPrevented()) {
        //console.log(e);
        return;
    }
    e.preventDefault();

    let btn = $(document.activeElement);
    let todo;
    if (
        btn.length &&
        form.has(btn) &&
        btn.is('button[type="submit"], input[type="submit"], input[type="image"]') &&
        btn.is('[name]')
    ) {
        todo = btn.attr('name');
        btnValue = $(btn).html();
    }

    //console.log("hier weiter");
    let fd = new FormData(this);
    $.ajax({
        type: 'POST',
        enctype: 'multipart/form-data',
        url: $(form).attr('action'),
        data: fd,
        processData: false,
        contentType: false,
        cache: false,
        timeout: 800000,
        beforeSend: () => {
            //console.log('beforeSend');
            let msg = JSON.parse(Base64.decode($('meta[name="forms.messages"]').attr('content')));
            $(btn).prop('disabled', true).html(msg.wait);
            $('#print-error').addClass('d-none').hide().find('ul').html('');
            $('#print-success').addClass('d-none').hide().html('');
            $(this).find('.is-invalid').removeClass('is-invalid');
        },
        success: (data) => {
            //console.log("SUCCESS: ", data);
            this.reset();
            $('.custom-file-label').html('');
            $('.selectpicker').val('').selectpicker("refresh");
            $('#print-success').removeClass('d-none').show().html(data.message);
        },
        error: (e) => {
            //console.log("ERROR:", e);
            if (e.status == 422) {
                //console.log(e.responseJSON.errors);
                //$('#print-error').removeClass('d-none').show().html(e.responseJSON.errors);
                $('#print-error').removeClass('d-none').show().find('ul').html('');
                if ((e.responseJSON).hasOwnProperty('errors')) {
                    Object.entries(e.responseJSON.errors).forEach(entry => {
                        const [key, value] = entry;
                        $('#print-error').find('ul').append('<li>' + value + '</li>');
                        $('#' + key).addClass('is-invalid');
                        //$('#' + key).next('.with-errors').html(value);
                    });
                }
                if ((e.responseJSON).hasOwnProperty('message')) {
                    //console.log(typeof(e.responseJSON.message));
                    if (typeof (e.responseJSON.message) === 'string') {
                        $('#print-error').find('ul').append('<li>' + e.responseJSON.message +
                            '</li>');
                    }
                    if (typeof (e.responseJSON.message) === 'object') {
                        Object.values(e.responseJSON.message).forEach(val => {
                            $('#print-error').find('ul').append('<li>' + val + '</li>');
                        });
                    }
                }
            } else {
                //console.log(e.responseJSON.message);
                $('#print-error').removeClass('d-none').show().html(e.responseJSON.message);
                location.reload();
            }
        },
        complete: () => {
            //console.log("COMPLETE");
            $(btn).prop('disabled', false).html(btnValue);
            $("html, body").animate({
                scrollTop: 0
            }, "slow");
        }
    });
})

let cp = 1;
let cpMax = $('meta[name="forms.cpmax"]').attr('content');
let cpRequired = ['cp_salutation_', 'cp_christianname_', 'cp_name_', 'cp_email_'];
let cpMin = $('#cp_filled').val();
for (var i = 2; i <= cpMax; i++) {
    if (i > cpMin) {
        $('.form-cp-' + i).find('input, select').prop('required', false);
    } else {
        $('.form-cp-' + i).removeClass('d-none').show();
    }
    $('#fpartner').validator('update');
}

$('#add_cp').on('click', function (e) {
    cp++;
    console.log(cp);
    cpRequired.forEach(function (val) {
        $('#' + val + cp).prop('required', true);
    });
    if (cp == cpMax) {
        $(this).prop('disabled', true);
    }
    if (cp <= cpMax) {
        $('.form-cp-' + cp).removeClass('d-none').show();
    } else {
        cp = cpMax;
    }
    for (var i = 2; i < cp; i++) {
        $('#del_cp_' + i).addClass('d-none').hide();
    }
    $('#cp_filled').val(cp);
    $('#fpartner').validator('update');
});

$('.del_cp').on('click', function (e) {
    cp--;
    let btn = $(document.activeElement);
    let cpid = $(btn).data('cp');
    cpRequired.forEach(function (val) {
        $('#' + val + cpid).prop('required', false);
    });
    if (cp < cpMax) {
        $('#add_cp').prop('disabled', false);
    }
    $('.form-cp-' + cpid).addClass('d-none').hide();
    $('#del_cp_' + cp).removeClass('d-none').show();
    $('#cp_filled').val(cp);
    $('#fpartner').validator('update');
});
